
import {client_id, client_secret} from "./../../config/index";
import http from "./http";
import Vue from 'vue';

const user_service = {
    oauth2Token(code) {  // 根据code获取token信息
        let data = {grant_type: 'authorization_code', client_id, client_secret, code};
        return http.post(`/authApi/oauth2/token`, http.adornData(data));
    },
    // 根据token获取用户信息
    oauth2UserInfo(access_token) {
        if (!access_token) {
            return Promise.reject('RequiredAccessToken');
        }
        return http.post(`/authApi/oauth2/userinfo`, http.adornData({access_token}));
    },
    // 刷新token
    oauth2RefreshToken(refresh_token) {
        if (!refresh_token) {
            return Promise.reject('RequiredRefreshToken');
        }
        return http.post(`/authApi/oauth2/refresh_token`, http.adornData({refresh_token},false));
    },
    setCookie(x){
        Vue.cookie.set('access_token', x.access_token, {maxAge: 1000 * x.expires_in * 0.5});
        Vue.cookie.set('refresh_token', x.refresh_token, {maxAge: 1000 * 60 * 60 * 6});
    },
    // 提交申请
    commitApply({iphone,userName,school,dept,email,schoolId,researchArea,userIdentity}){
        let token = Vue.cookie.get(('access_token'));
        return http.post('/api/check/one',http.adornData({token,iphone,userName,school,dept,email,schoolId,researchArea,userIdentity}))
    },
    // 检索机构
    searchOrganList(){
        return http.get('/api/organs');
    },
    // 查询啊是否再次申请
    getReapply(){
        if(!Vue.cookie.get(('access_token'))) {
            return Promise.reject('RequiredAccessToken');
        }
        return http.get('/api/check/through?token='+Vue.cookie.get(('access_token')));
    }
}
export default user_service;


// WEBPACK FOOTER //
// ./src/service/user_service.js